import { useSearchResultLoading } from './SearchActivity';
import TrackInfoRowsLoading from './TrackInfoRowsLoading';

const PlaceholderLine = ({ short = false }) => (
    <div className={`searchSkeletonBlock searchSkeletonLine${short ? ' searchSkeletonLineShort' : ''}`} />
);

const SearchResultsLoading = ({ kind, includesVerticalCardPadding = true }) => {
    useSearchResultLoading();
    const isHighlight = kind === 'highlights';

    return (
        <div className={`searchResultsLoading searchResultsLoading-${kind}`} role='status'
            aria-label={`Loading ${kind}`} aria-busy='true'>
            <div aria-hidden='true'>
                {kind === 'episodes' ?
                    <TrackInfoRowsLoading includesVerticalCardPadding={includesVerticalCardPadding} announce={false} /> :
                    Array.from({ length: isHighlight ? 2 : 4 }, (_, index) => (
                        <div key={index} className='searchSkeletonResult'>
                            <div className='searchSkeletonRow'>
                                <div className={`searchSkeletonBlock searchSkeletonArtwork${kind !== 'shows' ? ' searchSkeletonAvatar' : ''}`} />
                                <div className='searchSkeletonText'>
                                    <PlaceholderLine />
                                    <PlaceholderLine short />
                                </div>
                            </div>
                            {isHighlight && <>
                                <div className='searchSkeletonBlock searchSkeletonHighlight' />
                                <div className='searchSkeletonBlock searchSkeletonMetadata' />
                            </>}
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default SearchResultsLoading;
